import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import './PageTitle.scss';

const PageTitle = ({ title, children }) => {
  const navigate = useNavigate();

  // Only set data-page-title if title is a string
  const titleProps = typeof title === 'string' ? { 'data-page-title': title } : {};

  return (
    <div className="page-title">
      <div className="title-container">
        <ChevronRight className="back-arrow-icon" onClick={() => navigate(-1)} />
        <Typography variant="h1" className="title" {...titleProps}>
          {title}
        </Typography>
      </div>
      <div className="actions">
        {children}
      </div>
    </div>
  );
};

export default PageTitle;